import React from "react";
import { Route, Switch } from "react-router-dom";
// public
import PageNotFound from "../404";
import MyAccount from "../account";
import UpgradeBasicToPremium from "../accountUpgrade/basicToPremium";
import UpgradeBasicToPro from "../accountUpgrade/basicToPro";
import UpgradePremiumToPro from "../accountUpgrade/premiumToPro";
import Discourse from "../discourse";
import AccountComplete from "../accountComplete";
import AddNewFeatures from "../admin/addNewFeatures";
import AddNewInsurance from "../admin/addNewInsurance";
import AddNewUser from "../admin/addNewUser";
import Membership from "../membership";

// admin
import BlackList from "../admin/blacklist";
import BlackListDetails from "../admin/blacklistDetails";
import Categories from "../admin/categories";
import Dashboard from "../admin/dashboard";
import Security from "../admin/pages/security/index.tsx";
import PagesList from "../admin/pages";
import VideoLiabrary from "../admin/pages/videoLiabrary";
import EditCommunityCMS from "../admin/pages/community";
import EditHome from "../admin/pages/editHome";

import EditSingleInsuranceCMS from "../admin/pages/singleinsurance";
import EditResourceCMS from "../admin/pages/resource";
import UpcomingFeatureCMS from "../admin/pages/upcomingFeature";
import ResourceList from "../admin/resourceList";
import UpcomingFeature from "../admin/upcomingFeature";
import UpdateNewFeatures from "../admin/updateNewFeatures";
import UserDetails from "../admin/userDetails";
// import AdminLogin from "../adminLogin";
import Community from "../community";
import About from "../about";
import ConfirmEmail from "../confirmEmail";
import CancelAccount from "../cancelAccount";
import ContactUs from "../contactUs";
import ForgetPassword from "../forgetPassword";
import ForgetPasswordConfirmEmail from "../forgetPasswordConfirmEmail";
import ApplyForPlan from "../applyForPlan";
import HomePage from "../home";
import Login from "../login";
import PrivacyPolicy from "../privacyPolicy";
import ReportAProblem from "../reportAProblem";
import RequestAFeature from "../requestAFeature";
import ResetPassword from "../resetPassword";
import Resources from "../resources";
import ResourcesTemplate from "../resourcesTemplate";
import Signup from "../signup";
// import Success from "../success";
import SuccessMessage from "../successProud";
import TermsOfService from "../termsOfService";
import UpcomingFeatured from "../upcomingFeatured";
import Pricing from "../pricing";
import SelectInsurance from "../selectinsurance";
import HowItWorks from "../howitworks";
import WhatYouWillNeed from "../requiredthings";
import Insurance from "../insurance";
// redux
import SingleInsurance from "../SingleInsurance";
import InsuranceList from "../admin/insurancelist";
import PlanList from "../admin/insuranceplanlist";
import SubscriptionList from "../admin/subscriptionlist";
import addNewPlan from "../admin/addNewPlan";
import UpdateInsurance from "../admin/updateInsurance";
import UpdatePlan from "../admin/updatePlan";
import FaqList from "../admin/faqlist";
import AddNewFaq from "../admin/addNewFaq";
import UpdateFaq from "../admin/updateFaq";
import EditHowItWorks from "../admin/pages/howitworks";
import EditFaqCMS from "../admin/pages/faq";

import PublicRoute from "./_public";
import PrivateRoute from "./_private";
import ProRoute from "./_pro";
import PremiumRoute from "./_premium";
import { calculatorAndToolsSlugs, oldCalculatorAndToolsSlugs, progressNoteGenerator } from "../../utils/commonRouteUrl";
import businessAssociateAgreement from "../businessAssociateAgreement/index";
// REACT-LAZY LOADING COMPONENT

const UserDashboard = React.lazy(() => import("../dashboard"));
const Toolbox = React.lazy(() => import("../toolbox"));
const SessionFeeCalculator = React.lazy(() => import("../sessionFeeCalculator"));
const OutOfNetworkCalculator = React.lazy(() => import("../outOfNetworkCalculator"));
const OptimizeCalculator = React.lazy(() => import("../optimizeCalculator"));
const GoodFaithEstimateCalculator = React.lazy(() => import("../goodFaithEstimateCalculator"));
const ProgressNote = React.lazy(() => import("../progressNote"));
const AddProgressNote = React.lazy(() => import("../progressNote/addProgressNote"));
const AddIntakeNote = React.lazy(() => import("../intakeNote/addIntakeNote"));
const AddTreatmentPlanning = React.lazy(() => import("../treatmentPlanning/addTreatmentPlanning"));
const AddMentalHealthNote = React.lazy(() => import("../mentalHealth/addMentalNote"));
const AddTerminationNote = React.lazy(() => import("../terminationNote/addTerminationNote"));
const AddNewResource = React.lazy(() => import("../admin/addNewResource"));
const EditResource = React.lazy(() => import("../admin/editResource"));
const EditPrivacyCMS = React.lazy(() => import("../admin/pages/privacy"));
const EditTermsCMS = React.lazy(() => import("../admin/pages/trems"));
const EditBaaCMS = React.lazy(() => import("../admin/pages/baa/index"));
const EditInsuranceCMS = React.lazy(() => import("../admin/pages/insurance"));
const EditAbout = React.lazy(() => import("../admin/pages/about"));
const EditMembershipCMS = React.lazy(() => import("../admin/pages/membership"));
const addNewNotification = React.lazy(() => import("../admin/addNewNotification"));
const addAnnoucement = React.lazy(() => import("../admin/addAnnouncement"));
const listAnnouncement = React.lazy(() => import("../admin/addAnnouncement/ListAnnoucement"));
const updateNotification = React.lazy(() => import("../admin/updateNotification"));
const notification = React.lazy(() => import("../admin/notification"));
const InviteFriend = React.lazy(() => import("../admin/pages/inviteFriend"));
const Coupons = React.lazy(() => import("../admin/coupons/Coupons"));

const Blog = React.lazy(() => import("../admin/pages/blog/blog/ListBlogs"));
const AddBlog = React.lazy(() => import("../admin/pages/blog/blog/AddBlog"));
const authorReviewer = React.lazy(() => import("../admin/pages/blog/author/AuthorReviewer"));
const blogConfriguration = React.lazy(() => import("../admin/pages/blog/blogConfriguration/BlogConfriguration"));
const addAuthorReviewer = React.lazy(() => import("../admin/pages/blog/author/AddAuthorReviewer"));
const subCategory = React.lazy(() => import("../admin/pages/blog/category/SubCategory"));
const UserList = React.lazy(() => import("../admin/userlist"));
const AdminRoute = React.lazy(() => import("./_admin"));
const AddPhoneConsultNote = React.lazy(() => import("../phoneConsultNote/addPhoneConsultNote"));
const MemberBenefit = React.lazy(() => import("../admin/pages/memberBenefits"));
const AddMember = React.lazy(() => import("../admin/pages/memberBenefits/addMember/AddMember"));

// REACT-LAZY LOADING COMPONENT
// const UserDashboard = React.lazy(() => import("../dashboard"));
// const ProgressNot = React.lazy(() => import("../progressNote"));

const Routes = () => {
  return (
    <Switch>
      <PublicRoute component={HomePage} path="/" exact />
      <PublicRoute component={Pricing} path="/membership-old" exact />
      <PublicRoute component={Membership} path="/membership" exact />
      <PublicRoute component={Membership} path="/membership/:key" exact />
      <PrivateRoute component={Toolbox} path={calculatorAndToolsSlugs.toolbox} exact />
      <PrivateRoute component={UserDashboard} path="/dashboard" exact />
      <PrivateRoute component={SessionFeeCalculator} path={calculatorAndToolsSlugs.sessionFeeCalculator()} exact />
      <ProRoute component={AddMentalHealthNote} path="/therapy-note/add-mental-health" exact />
      <ProRoute component={AddMentalHealthNote} path="/therapy-note/edit-mental-health/:id" exact />
      <ProRoute component={AddIntakeNote} path="/therapy-note/add-intakenote" exact />
      <ProRoute component={AddIntakeNote} path="/therapy-note/edit-intakenote/:id" exact />
      <ProRoute component={AddTreatmentPlanning} path="/therapy-note/add-treatment-planning" exact />
      <ProRoute component={AddTreatmentPlanning} path="/therapy-note/edit-treatment-planning/:id" exact />
      <ProRoute component={ProgressNote} path={`${progressNoteGenerator}`} exact />
      <ProRoute component={AddProgressNote} path="/therapy-note/add-progressnote" exact />
      <ProRoute component={AddProgressNote} path="/therapy-note/edit-progressnote/:id" exact />
      <ProRoute component={AddTerminationNote} path="/therapy-note/add-termination-summary" exact />
      <ProRoute component={AddTerminationNote} path="/therapy-note/edit-termination-summary/:id" exact />
      <ProRoute component={AddPhoneConsultNote} path="/therapy-note/add-phone-consult-note" exact />
      <ProRoute component={AddPhoneConsultNote} path="/therapy-note/edit-phone-consult-note/:id" exact />
      <PublicRoute component={UpcomingFeatured} path="/upcoming-features" exact />
      <PublicRoute component={SingleInsurance} path="/insurance/:insurance_slug" exact />
      <PublicRoute component={Insurance} path="/insurance" exact />
      <PublicRoute component={HowItWorks} path="/how-it-works" exact />
      <PublicRoute component={WhatYouWillNeed} path="/what-you-will-need" exact />
      <PublicRoute component={RequestAFeature} path="/request-a-feature" exact />
      <PublicRoute component={SelectInsurance} path="/select-insurance" exact />
      <PublicRoute component={ReportAProblem} path="/report-a-problem" exact />
      <PublicRoute component={ContactUs} path="/contact-us" exact />

      <PublicRoute component={MyAccount} path="/my-account" exact />

      <PublicRoute component={Discourse} path="/discourse/sso" exact />
      <PublicRoute component={TermsOfService} path="/terms-of-service" exact />
      <PublicRoute component={businessAssociateAgreement} path="/business-associate-agreement" exact />
      <PublicRoute component={PrivacyPolicy} path="/privacy-policy" exact />
      <PublicRoute component={SuccessMessage} path="/success-message" exact />
      <PublicRoute component={Resources} path="/resources" exact />
      <PublicRoute component={Resources} path="/resources/:categories" exact />
      <PublicRoute component={Login} path="/login" exact />
      {/* <PublicRoute component={AdminLogin} path="/admin" exact /> */}
      <PublicRoute component={Signup} path="/signup" exact />
      <PublicRoute component={Signup} path="/signup/:refer" exact />

      <AdminRoute component={Blog} path="/admin/pages/blog" exact />
      <AdminRoute component={AddBlog} path="/admin/pages/blog/add-blog" exact />
      <AdminRoute component={AddBlog} path="/admin/pages/blog/edit-blog/:id" exact />
      <AdminRoute component={authorReviewer} path="/admin/pages/blog/author-reviewer" exact />
      <AdminRoute component={blogConfriguration} path="/admin/pages/blog/blog-configuration" exact />
      <AdminRoute component={subCategory} path="/admin/pages/blog/sub-category" exact />
      <AdminRoute component={addAuthorReviewer} path="/admin/pages/blog/add-author-reviewer" exact />
      <AdminRoute component={addAuthorReviewer} path="/admin/pages/blog/edit-author-reviewer/:id" exact />

      <AdminRoute component={authorReviewer} path="/admin/form-reviewer" exact />
      <AdminRoute component={addAuthorReviewer} path="/admin/add-form-reviewer" exact />
      <AdminRoute component={addAuthorReviewer} path="/admin/edit-form-reviewer/:id" exact />

      <AdminRoute component={MemberBenefit} path="/admin/pages/member-benefits" exact />
      <AdminRoute component={AddMember} path="/admin/pages/member-benefits/add-member" exact />
      <AdminRoute component={AddMember} path="/admin/pages/member-benefits/edit-member/:id" exact />

      <PublicRoute component={CancelAccount} path="/cancel-account" exact />

      <PublicRoute component={UpgradeBasicToPremium} path="/account-upgrade/basic-premium" exact />
      <PublicRoute component={UpgradeBasicToPremium} path="/account-upgrade/basic-premium-month" exact />
      <PublicRoute component={UpgradeBasicToPro} path="/account-upgrade/basic-pro" exact />
      <PublicRoute component={UpgradeBasicToPro} path="/account-upgrade/basic-pro-month" exact />
      <PublicRoute component={UpgradePremiumToPro} path="/account-upgrade/premium-pro" exact />
      <PublicRoute component={UpgradePremiumToPro} path="/account-upgrade/premium-pro-month" exact />

      <PublicRoute component={ConfirmEmail} path="/confirm-email" exact />
      <PublicRoute component={ForgetPassword} path="/forget-password" exact />
      <PublicRoute component={ApplyForPlan} path="/apply-for-plan" exact />
      <PublicRoute component={ForgetPasswordConfirmEmail} path="/forget-password-confirm-email" exact />
      <PublicRoute component={ResetPassword} path="/reset-password" exact />
      {/* <PublicRoute component={Success} path="/success" exact /> */}
      <PublicRoute component={About} path="/about" exact />

      <PublicRoute component={Community} path="/community" exact />
      <PublicRoute component={ResourcesTemplate} path="/resources/:id/:slug" exact />
      <PublicRoute component={AccountComplete} path="/account-complete" exact />

      <PremiumRoute component={OptimizeCalculator} path={calculatorAndToolsSlugs.therapistDeductionsCalculator()} exact />
      <PremiumRoute component={OptimizeCalculator} path={oldCalculatorAndToolsSlugs.therapistDeductionsCalculator()} exact />
      <ProRoute component={GoodFaithEstimateCalculator} path={calculatorAndToolsSlugs.goodFaithEstimateCalculator()} exact />
      <ProRoute component={OutOfNetworkCalculator} path={calculatorAndToolsSlugs.outOfNetworkCalculator()} exact />

      <AdminRoute component={BlackList} path="/admin/blacklist" exact />
      <AdminRoute component={BlackListDetails} path="/admin/blacklist/:id/:slug" exact />
      <AdminRoute component={notification} path="/admin/notification" exact />
      <AdminRoute component={addNewNotification} path="/admin/notification/add-new-notification" exact />
      <AdminRoute component={addAnnoucement} path="/admin/addAnnouncement" exact />
      <AdminRoute component={listAnnouncement} path="/admin/list-announcement" exact />
      <AdminRoute component={updateNotification} path="/admin/notification/update-notification/:id" exact />
      <AdminRoute component={Dashboard} path="/admin/dashboard" exact />
      <AdminRoute component={Security} path="/admin/pages/security" exact />
      <AdminRoute component={UserList} path="/admin/users" exact />
      <AdminRoute component={AddNewUser} path="/admin/add-new-user" exact />
      <AdminRoute component={UserDetails} path="/admin/users/:id/:slug" exact />
      <AdminRoute component={ResourceList} path="/admin/resources" exact />

      <AdminRoute component={FaqList} path="/admin/insurances/faqs" exact />
      <AdminRoute component={AddNewFaq} path="/admin/insurances/faqs/add-new-faq" exact />
      <AdminRoute component={UpdateFaq} path="/admin/insurances/faqs/:faq_id/update" exact />

      <AdminRoute component={InsuranceList} path="/admin/insurances" exact />
      <AdminRoute component={AddNewInsurance} path="/admin/insurances/add-new-insurance" exact />
      <AdminRoute component={UpdateInsurance} path="/admin/insurance/:insurance_id/update" exact />
      <AdminRoute component={PlanList} path="/admin/insurance/:insurance_id/plans" exact />
      <AdminRoute component={addNewPlan} path="/admin/insurance/:insurance_id/add-new-plan" exact />
      <AdminRoute component={UpdatePlan} path="/admin/insurance/:insurance_id/plan/:plan_id/update" exact />
      <AdminRoute component={SubscriptionList} path="/admin/insurance/:insurance_id/plan/:plan_id/subscriptions" exact />

      <AdminRoute component={AddNewResource} path="/admin/add-new-resource" exact />

      <AdminRoute component={EditResource} path="/admin/resources/:id/:slug" exact />
      <AdminRoute component={Categories} path="/admin/categories" exact />
      <AdminRoute component={UpcomingFeature} path="/admin/upcoming-features" exact />
      <AdminRoute component={AddNewFeatures} path="/admin/add-feature" exact />
      <AdminRoute component={UpdateNewFeatures} path="/admin/upcoming-features/:id/:slug" exact />
      <AdminRoute component={PagesList} path="/admin/pages" exact />
      <AdminRoute component={VideoLiabrary} path="/admin/pages/video-tutorials" exact />
      <AdminRoute component={EditHome} path="/admin/pages/home" exact />
      <AdminRoute component={EditResourceCMS} path="/admin/pages/resources" exact />
      <AdminRoute component={UpcomingFeatureCMS} path="/admin/pages/upcoming-features" exact />
      <AdminRoute component={EditCommunityCMS} path="/admin/pages/community" exact />
      <AdminRoute component={EditTermsCMS} path="/admin/pages/terms" exact />
      <AdminRoute component={EditBaaCMS} path="/admin/pages/business-associate-agreement" exact />
      <AdminRoute component={EditPrivacyCMS} path="/admin/pages/privacy-policy" exact />
      <AdminRoute component={EditFaqCMS} path="/admin/pages/toolbox" exact />
      <AdminRoute component={EditInsuranceCMS} path="/admin/pages/insurance" exact />
      <AdminRoute component={EditMembershipCMS} path="/admin/pages/membership" exact />

      <AdminRoute component={InviteFriend} path="/admin/pages/coupon" exact />

      <AdminRoute component={Coupons} path="/admin/coupons" exact />

      <AdminRoute component={EditSingleInsuranceCMS} path="/admin/insurances/:insurance_slug" exact />

      <AdminRoute component={EditHowItWorks} path="/admin/pages/how-it-works" exact />
      <AdminRoute component={EditAbout} path="/admin/pages/about" exact />

      <Route component={PageNotFound} exact />
    </Switch>
  );
};
export default Routes;
